import { FileType } from 'features/declaration/models/schemas/fileSchemas'
import { CreateDocumentRequestV3 } from '../../../../api/models/create-document-request-v3'
import { UpdateDocumentRequestV3 } from '../../../../api/models/update-document-request-v3'

export type DocumentType = 'TRANSPORT' | 'PREVIOUS' | 'SUPPORTING' | 'NOTE'

export type DocumentFileSave = {
  id: number | null
  fileName: string
  documentId: number | null
  mimeType: string
  sequenceNumber:number
  deleted: boolean
  uuid: string | null
  file: File | null
  fileBlob: Blob | null
  url: string | null
}

type DocumentBase = {
  type: DocumentType
  sequenceNumber: number
  documentType: string
  referenceNumber: string
  deleted: boolean
}

type DocumentCreateBase = DocumentBase & {
  files: DocumentFileSave[]
}

type DocumentUpdateBase = DocumentBase & {
  id: number
  files: DocumentFileSave[]
}

type TransportDocumentFields = {
  type: 'TRANSPORT'
}

type PreviousDocumentFields = {
  type: 'PREVIOUS'
  complementOfInformation: string
  transportDocumentReferenceNumber: string
  procedureType: string | null
}

type SupportingDocumentFields = {
  type: 'SUPPORTING'
  complementOfInformation: string
  documentLineNumber: number | null
}

type NoteDocumentFields = {
  type: 'NOTE'
  transitOperationId: number | null
}

export type TransportDocumentCreate = DocumentCreateBase & TransportDocumentFields
export type TransportDocumentUpdate = DocumentUpdateBase & TransportDocumentFields
export type PreviousDocumentCreate = DocumentCreateBase & PreviousDocumentFields
export type PreviousDocumentUpdate = DocumentUpdateBase & PreviousDocumentFields
export type SupportingDocumentCreate = DocumentCreateBase & SupportingDocumentFields
export type SupportingDocumentUpdate = DocumentUpdateBase & SupportingDocumentFields
export type NoteDocumentCreate = DocumentCreateBase & NoteDocumentFields
export type NoteDocumentUpdate = DocumentUpdateBase & NoteDocumentFields

export type DocumentCreate =
  | TransportDocumentCreate
  | PreviousDocumentCreate
  | SupportingDocumentCreate
  | NoteDocumentCreate

export type DocumentUpdate =
  | TransportDocumentUpdate
  | PreviousDocumentUpdate
  | SupportingDocumentUpdate
  | NoteDocumentUpdate

export type DocumentSave = DocumentCreate | DocumentUpdate

export type CreateDocumentRequestWithFiles = {
  request: CreateDocumentRequestV3
  files: FileType[]
}

export type UpdateDocumentRequestWithFiles = {
  request: UpdateDocumentRequestV3
  files: FileType[]
}

export const isTransportDocumentCreate = (d: DocumentCreate): d is TransportDocumentCreate => d.type === 'TRANSPORT'
export const isPreviousDocumentCreate = (d: DocumentCreate): d is PreviousDocumentCreate => d.type === 'PREVIOUS'
export const isSupportingDocumentCreate = (d: DocumentCreate): d is SupportingDocumentCreate => d.type === 'SUPPORTING'
export const isTransportDocumentUpdate = (d: DocumentUpdate): d is TransportDocumentUpdate => d.type === 'TRANSPORT'
export const isPreviousDocumentUpdate = (d: DocumentUpdate): d is PreviousDocumentUpdate => d.type === 'PREVIOUS'
export const isSupportingDocumentUpdate = (d: DocumentUpdate): d is SupportingDocumentUpdate => d.type === 'SUPPORTING'

export type DocumentSaveBatch = {
  creates: DocumentCreate[]
  updates: DocumentUpdate[]
}
